export default "__VITE_ASSET__FHDJaPcL__"